import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'WeatherReading';

export type WeatherReadingProps = {
  forecastTemperature?: number;
  forecastHumidity?: number;
  forecastRainfall?: number;
  forecastRainfallIntensity?: number;
  forecastRainfallDuration?: number;
  forecastWind?: number;
  reportedTemperature?: number;
  reportedHumidity?: number;
  reportedRainfall?: number;
  reportedRainfallDepth?: number;
  reportedRainfallDuration?: number;
  reportedWind?: number;
};

export class WeatherReading extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  forecastTemperature?: number;
  forecastHumidity?: number;
  forecastRainfall?: number;
  forecastRainfallIntensity?: number;
  forecastRainfallDuration?: number;
  forecastWind?: number;
  reportedTemperature?: number;
  reportedHumidity?: number;
  reportedRainfall?: number;
  reportedRainfallDepth?: number;
  reportedRainfallDuration?: number;
  reportedWind?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      forecastTemperature: {
        type: 'Number',
        editable: true,
        label: 'Forecast Temperature',
        name: 'forecastTemperature',
        description: 'Weather forecast for temperature (°C) (today, tomorrow, 7 days)',
      },
      forecastHumidity: {
        type: 'Number',
        editable: true,
        label: 'Forecast Humidity',
        name: 'forecastHumidity',
        description: 'Weather forecast for humidity (RH) (today, tomorrow, 7 days)',
      },
      forecastRainfall: {
        type: 'Number',
        editable: true,
        label: 'Forecast Rainfall',
        name: 'forecastRainfall',
        description: 'Weather forecast for rainfall (mm) (today, tomorrow, 7 days)',
      },
      forecastRainfallIntensity: {
        type: 'Number',
        editable: true,
        label: 'Forecast Rainfall Intensity',
        name: 'forecastRainfallIntensity',
        description: 'Weather forecast for rainfall intensity (mm/hour) (today, tomorrow, 7 days)',
      },
      forecastRainfallDuration: {
        type: 'Number',
        editable: true,
        label: 'Forecast Rainfall Duration',
        name: 'forecastRainfallDuration',
        description: 'Weather forecast for duration of rainfall (hour & minute) (today, tomorrow, 7 days)',
      },
      forecastWind: {
        type: 'Number',
        editable: true,
        label: 'Forecast Wind',
        name: 'forecastWind',
        description: 'Weather forecast for wind (km/hr) (today, tomorrow, 7 days)',
      },
      reportedTemperature: {
        type: 'Number',
        editable: true,
        label: 'Reported Temperature',
        name: 'reportedTemperature',
        description: 'Current reported weather conditions for temperature (°C)',
      },
      reportedHumidity: {
        type: 'Number',
        editable: true,
        label: 'Reported Humidity',
        name: 'reportedHumidity',
        description: 'Current reported weather conditions for humidity (RH)',
      },
      reportedRainfall: {
        type: 'Number',
        editable: true,
        label: 'Reported Rainfall',
        name: 'reportedRainfall',
        description: 'Current reported weather conditions for rainfall (mm)',
      },
      reportedRainfallDepth: {
        type: 'Number',
        editable: true,
        label: 'Reported Rainfall Depth',
        name: 'reportedRainfallDepth',
        description: 'Current reported weather conditions for rainfall intensity (mm/hour)',
      },
      reportedRainfallDuration: {
        type: 'Number',
        editable: true,
        label: 'Reported Rainfall Duration',
        name: 'reportedRainfallDuration',
        description: 'Current recorded duration of reported rainfall event (hour & minute)',
      },
      reportedWind: {
        type: 'Number',
        editable: true,
        label: 'Reported Wind',
        name: 'reportedWind',
        description: 'Current reported weather conditions for wind (km/hr)',
      },
    };
  };
}
